import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  if (!Number(to.params.assessment)) return show404()
})
